module.exports = __webpack_public_path__ + "img/igreja-matriz.89ac098b.jpg";